import { ModelAdapter } from "../../../../../shared/models/adapter/ModelAdapter";
import { FahrzeugDetailApi } from "../../../../../shared/models/apim/FahrzeugDetailApi";
import { AppFormModel } from "./AppFormModel";
import { FahrzeugModel } from "../../../../../shared/models/view/Fahrzeug";
import { GarageTypeApi } from "../../../../../shared/models/generated/FahrzeugdatenGarageTypeApi";

// TODO remove FahrzeugdatenRepositoryApi and MarkenStatusApi after generated models are fixed
export enum FahrzeugdatenRepositoryApi {
	None = 0, Autodaten = 1, Motorraddaten = 2, HermesAutodaten = 3, HermesMotorraddaten = 4, AutoUndMotorraddaten = 5, HermesAutoundMotorraddaten = 6
}

export enum MarkenStatusApi {
	NurNeueFahrzeuge = 0, AlleFahrzeuge = 1
}

export class AppModelAdapter extends ModelAdapter {

	public static updateFahrzeugFormModel(response: FahrzeugDetailApi, formModel: AppFormModel): void {
		formModel.Fahrzeug.Fahrzeugart = 1;
		formModel.Fahrzeug.FahrzeugBezeichnung = response.Eckdaten.Fahrzeug;
		formModel.Fahrzeug.Modell = response.Eckdaten.Modell;
		formModel.Fahrzeug.Baureihe = response.Eckdaten.Baureihe;
		formModel.Fahrzeug.BaureiheGeneration = response.Eckdaten.BaureiheGeneration;
		formModel.Fahrzeug.KraftstoffArt = response.Eckdaten.Kraftstoffart;
		formModel.Fahrzeug.Marke = response.Eckdaten.Marke;
		formModel.Fahrzeug.VerbrauchGesamtMitEinheit = response.Eckdaten.VerbrauchGesamtMitEinheit;
		formModel.Fahrzeug.VerbrauchGesamtWltpMitEinheit = response.Eckdaten.VerbrauchGesamtWltpMitEinheit;
		formModel.Fahrzeug.KfzId = response.Eckdaten.KfzId;
		formModel.Fahrzeug.GrundpreisMitEinheit = response.Eckdaten.GrundpreisMitEinheit;
		formModel.Fahrzeug.LeistungKw = response.Eckdaten.LeistungKw;
		formModel.Fahrzeug.LeistungPs = response.Eckdaten.LeistungPs;
		formModel.Fahrzeug.HubraumMitEinheit = response.Eckdaten.HubraumMitEinheit;
		formModel.Fahrzeug.BildDateiName = response.Eckdaten.Bild.Name;
		formModel.Fahrzeug.BildAltText = response.Eckdaten.Bild.AltBeschreibung;
	}

	public static getFahrzeugdatenRepository(vehicleModel: FahrzeugModel): FahrzeugdatenRepositoryApi {
		if (!vehicleModel) {
			return FahrzeugdatenRepositoryApi.None;
		}
		switch (vehicleModel.Fahrzeugart) {
			case GarageTypeApi.Pkw:
				return FahrzeugdatenRepositoryApi.Autodaten;
			case GarageTypeApi.Motorrad:
				return FahrzeugdatenRepositoryApi.HermesMotorraddaten;
			default:
				return FahrzeugdatenRepositoryApi.HermesAutoundMotorraddaten;
		}
	}

	public static getDefaultMarkenStatus(): MarkenStatusApi {
		return MarkenStatusApi.AlleFahrzeuge;
	}
}